import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-shell-admin-section',
  templateUrl: './shell-admin-section.component.html',
  styleUrl: './shell-admin-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellAdminSectionComponent {
   readonly title = input.required<string>();
  readonly description = input<string | null>(null);
}
